/*
 * @Author: wufei
 * @Date: 2020-08-07 11:01:31
 * @LastEditTime: 2020-12-09 11:25:50
 * @Description:
 * @FilePath: \mobile-revive\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from '@/filters'
import './styles/common.scss'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import { DDEvent, getURLTokenToDDToken, FSEvent } from '@/api/dd' // getURLTokenToDDToken
import moment from 'moment'
import * as dd from 'dingtalk-jsapi'
import echarts from 'echarts'
import '@/assets/iconfont/iconfont.css'

Vue.prototype.$echarts = echarts

import Vconsole from 'vconsole'
// import utilSrc from './utils/util'
Vue.use(ElementUI)
// Vue.use(new Vconsole())
// register global utility filters.
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

import { getSelfInfo, getWXToken } from '@/api/dd'
const getUserinfo = async() => {
    await getSelfInfo().then(res => {
        sessionStorage.setItem('userInfo', JSON.stringify(res.name))
        sessionStorage.setItem('userDetail', JSON.stringify(res))
        sessionStorage.setItem('userMobile', JSON.stringify(res.mobile))
        sessionStorage.setItem('userMobile', JSON.stringify(res.mobile))
        store.commit('setUserName', res.name)
        let info = {
            type: 0,
            areaDeptId: res.areaDeptId,
            cityCompId: res.cityCompId
        }
        if (!res.areaDeptId) {
            info.type = 1
        } else if (!res.cityCompId) {
            info.type = 2
        } else {
            info.type = 3
        }
        sessionStorage.setItem('userBelone', JSON.stringify(info))
        console.log('userBelone', JSON.stringify(info))
    })
}

function getUrlParams(url) {
    let str = url // 取得整个地址栏
    let num = str.indexOf('?')
    let tokenValue = ''
    if (num > 0) {
        str = str.substr(num + 1)
        let paramArr = str.split('&')
        paramArr.forEach(item => {
            if (item.indexOf('token') >= 0) {
                let index = item.indexOf('=')
                tokenValue = item.slice((index + 1))
            }
        })
        return tokenValue
    }
    return false
}
function GetQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    var r = window.location.search.substr(1).match(reg)
    if (r != null) { return unescape(r[2]) }
    return null
}
router.beforeEach(async(to, from, next) => {
    let _paq = window._paq
    _paq.push(['setDocumentTitle', to.meta.title])
    _paq.push(['trackPageView'])
    if (sessionStorage.ddToken) {
        await getUserinfo()
        next()
    } else {
        if (location.href.includes('token')) {
            let url = location.href
            let urlToken = decodeURIComponent(getUrlParams(url))
            getURLTokenToDDToken(urlToken).then(async res => {
                sessionStorage.setItem('ddToken', res)
                await getUserinfo()
                next()
            })
        } else {
            if (dd.env.platform != 'notInDingTalk') {
                console.log('钉钉')
                DDEvent().then(async() => {
                    await getUserinfo()
                    next()
                }).catch(err => console.log(err))
            }
            if (navigator.userAgent.includes('Lark')) {
                console.log('飞书')
                if (location.href.includes('code')) {
                    console.log(GetQueryString('code'))
                    var code = GetQueryString('code')
                    FSEvent({
                        code: code,
                        clientId: process.env.VUE_APP_CLIENTE_ID,
                        clientSecret: process.env.VUE_APP_CLIENTE_SECRET,
                        redirectUri: process.env.VUE_APP_REDIRECT_URI,
                        sso: process.env.VUE_APP_SSO
                    }).then(async res => {
                        console.log(12)
                        sessionStorage.setItem('ddToken', res)
                        await getUserinfo()
                        next()
                    })
                } else {
                // window.open(`https://open.feishu.cn/open-apis/authen/v1/ssssindex?redirect_uri=${process.env.VUE_APP_REDIRECT_URI}&app_id=${process.env.VUE_APP_ID}&state=0`)
                    window.location.href = `${process.env.VUE_APP_SSO}/siam/oauth2.0/authorize?redirect_uri=${process.env.VUE_APP_REDIRECT_URI}&client_id=${process.env.VUE_APP_CLIENTE_ID}&response_type=code`
                }
            }
        }

    }
})
// 全局过滤器
Vue.filter('dateFmt', (input, formatString = 'YYYY-MM-DD') => {
    // es5函数参数设置默认值
    // const lastFormatString = formatString || ''
    // moment(input) 把时间字符串转成时间对象
    // format(formatString) 把时间对象，按照指定格式，格式化成符合条件的字符串
    return moment(input).format(formatString)

})
/** dd相关 end*/
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
